import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/**
 * Simulation / Réel toggle — controls whether runs target the real Lab
 * systems (real) or the local mock SSH server (simulation).
 * Surfaces the existing /api/mock/* endpoints on the backend.
 */
export type ExecutionMode = 'simulation' | 'real';

interface ModeState {
  mode: ExecutionMode;
  setMode: (m: ExecutionMode) => void;
  toggle: () => void;
}

export const useModeStore = create<ModeState>()(
  persist(
    (set, get) => ({
      mode: 'simulation',
      setMode: (m) => set({ mode: m }),
      toggle: () => set({ mode: get().mode === 'simulation' ? 'real' : 'simulation' }),
    }),
    {
      name: 'lab.mode',
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
